// Stan: inicjalizacja.
export const STATE__INITIALIZING = 'INITIALIZING';
// Stan: użytkownik anonimowy.
export const STATE__ANONYMOUS = 'ANONYMOUS';
// Stan: użytkownik zalogowany.
export const STATE__AUTHORIZED = 'AUTHORIZED';
// Stan: użytkownik niezalogowany.
export const STATE__UNAUTHORIZED = 'UNAUTHORIZED';
